import { useEffect, useState } from 'react';
import { useTranslation } from '@hooks';
import ModalShell from './ModalShell';
import ModalConfirm from './ModalConfirm';

const ModalBase = ({ isOpen, handleClose, isDirty = false, ...shellProps }) => {
    const { t } = useTranslation();
    const [isDiscardPromptOpen, setIsDiscardPromptOpen] = useState(false);

    useEffect(() => {
        if (!isOpen) setIsDiscardPromptOpen(false);
    }, [isOpen]);

    const requestClose = (...closeArgs) => {
        if (isDirty) {
            setIsDiscardPromptOpen(true);
        } else {
            handleClose(...closeArgs);
        }
    };

    const discardChanges = () => {
        setIsDiscardPromptOpen(false);
        handleClose();
    };

    return (
        <>
            <ModalShell {...shellProps} isOpen={isOpen} handleClose={handleClose && requestClose} />
            {isDiscardPromptOpen && (
                <ModalConfirm
                    isOpen
                    handleClose={() => setIsDiscardPromptOpen(false)}
                    title={t('common.unsavedChangesTitle')}
                    description={t('common.unsavedChangesDescription')}
                    onPrimaryAction={discardChanges}
                    primaryActionText={t('buttons.discard')}
                    primaryActionType="danger"
                    aboveModal
                />
            )}
        </>
    );
};

export default ModalBase;
